export function StatusPill({ value }: { value: string }) {
  const normalized = value.toLowerCase().replaceAll("_", "-");
  return (
    <span className={`status-pill status-pill--${normalized}`}>{value.replaceAll("_", " ")}</span>
  );
}
